export default "__VITE_ASSET__6UslWtEh__"